import { render, staticRenderFns } from "./AllDocuments.vue?vue&type=template&id=74cb2d6b"
import script from "./AllDocuments.vue?vue&type=script&lang=ts"
export * from "./AllDocuments.vue?vue&type=script&lang=ts"
import style0 from "./AllDocuments.vue?vue&type=style&index=0&id=74cb2d6b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports